export const DEFAULT_THEME = 'red';

const THEME_CLASSNAMES = ['theme-red', 'theme-brown'];

export const normalizeThemeColor = (value) =>
  String(value || '').toLowerCase() === 'brown' ? 'brown' : DEFAULT_THEME;

export const applyTheme = (theme) => {
  if (typeof document === 'undefined') {
    return normalizeThemeColor(theme);
  }

  const normalized = normalizeThemeColor(theme);
  const body = document.body;

  THEME_CLASSNAMES.forEach((className) => body.classList.remove(className));
  body.classList.add(`theme-${normalized}`);

  return normalized;
};
